import { parseRRule, isSameRRule } from "../utils/recurring-events/rRuleString.mjs";
import { projectRRuleToTimezone } from "../utils/recurring-events/projectRRuleToTimezone.mjs";
import { getRecurringEventOccurrencesForVisibleDays } from "../utils/recurring-events/getRecurringEventOccurrencesForVisibleDays.mjs";
import { updateRecurringEvent } from "../utils/recurring-events/updateRecurringEvent.mjs";
import { applyDataTimezoneToEventUpdate } from "../utils/recurring-events/applyDataTimezoneToEventUpdate.mjs";
import { computePresets, getDefaultPresetKey, getWeeklyDays, getMonthlyReference } from "../utils/recurring-events/presets.mjs";
export const schedulerRecurringEventsPlugin = {
  parseRRule,
  projectRRuleToTimezone,
  getOccurrencesForVisibleDays: getRecurringEventOccurrencesForVisibleDays,
  updateRecurringEvent,
  applyDataTimezoneToEventUpdate,
  computePresets,
  getDefaultPresetKey,
  isSameRRule,
  getWeeklyDays,
  getMonthlyReference
};